import { render, staticRenderFns } from "./DebtSupplier.vue?vue&type=template&id=29c0d498&scoped=true&"
import script from "./DebtSupplier.vue?vue&type=script&lang=js&"
export * from "./DebtSupplier.vue?vue&type=script&lang=js&"
import style0 from "./DebtSupplier.vue?vue&type=style&index=0&id=29c0d498&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29c0d498",
  null
  
)

export default component.exports